import { useFormikContext } from "formik";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Project } from "../../../types/project";
export default function ActivityTable() {
  const { values } = useFormikContext<Project>();
  const { t } = useTranslation();
  const rowStyle = {
    padding: "15px",
  };
  return (
    <Paper>
      <Table>
        <TableBody>
          {/* removed variant="head" */}
          <TableRow sx={rowStyle}>
            <TableCell>
              <Typography fontSize={20} color={"primary"}>
                {t("labels.activities")}
              </Typography>
            </TableCell>
          </TableRow>
          {values.activities.map((a, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{a.activity}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
